export const pushRouterWithDebug = (router, route, ...args) => {
  if (process.env.IS_DEBUG) {
    const params = window?.location?.search;
    return router.push(`${route}${params}`, ...args);
  }

  return router.push(route, ...args);
};

export class URLQuery {
  constructor() {
    this.searchParams = new URLSearchParams(window.location.search);
    this.queries = {};
  }

  get(key, value) {
    if (value !== undefined) this.queries[key] = value;

    if (this.queries[key] !== undefined) return this.queries[key];

    if (this.searchParams) {
      value = this.searchParams.get(key);
      if (value === "0") value = 0;
      else if (value === "false" || value === null) value = false;
      else if (value === "") value = true;
    } else {
      let escapedKey = encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&");
      value = decodeURIComponent(
        window.location.search.replace(
          new RegExp(`^(?:.*?[&?]${escapedKey}(?:\=([^&]*)|[&$]))?.*$`, "i"),
          "$1"
        )
      );
      if (value == "0") {
        value = 0;
      } else if (value == "false") {
        value = false;
      } else if (!value.length) {
        value = new RegExp(`[&?]${escapedKey}(?:[&=]|$)`, "i").test(
          window.location.search
        );
      }
    }
    this.queries[key] = value;

    return value;
  }
}
